window.scrollToDiv = function(a, b) {
	var c = a.offset().top - b;
	$("html, body").stop().animate({
		scrollTop: c
	}, 800, "swing")
};
